import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1efec47a")
const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = { class: "p-d-flex p-grid p-col-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "text-size-14 text-font-inter font-weight-500 p-col-3" }, "Programa", -1)
const _hoisted_4 = { class: "p-col-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "text-size-14 text-font-inter font-weight-500 p-col-6" }, "Programa asignado para visualizar", -1)
const _hoisted_6 = { class: "p-col-4" }
const _hoisted_7 = { class: "p-col-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "text-size-14 text-font-inter text-dark-blue-gray-brain font-weight-500" }, "Programa PDF", -1)
const _hoisted_9 = { href: "#programa.pdf" }
const _hoisted_10 = { class: "p-input-icon-right" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cloud-download" }, null, -1)
const _hoisted_12 = { class: "p-grid p-px-5 p-fluid" }
const _hoisted_13 = {
  key: 1,
  class: "p-col-12"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SyllabusSelector = _resolveComponent("SyllabusSelector")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Unit = _resolveComponent("Unit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_SyllabusSelector, {
              onClickOnVersion: _ctx.changePdfPreview,
              loading: _ctx.loading,
              syllabum: _ctx.syllabumActive,
              placeholder: "Elegir versión"
            }, null, 8, ["onClickOnVersion", "loading", "syllabum"])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", null, [
          _createElementVNode("a", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_InputText, {
                style: {"text-color":"green"},
                type: "text",
                modelValue: _ctx.programa,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.programa = $event)),
                disabled: true
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Divider),
    _createElementVNode("div", _hoisted_12, [
      (!_ctx.unitPlans)
        ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unitPlans, (unit, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "p-col-12",
          key: unit.name
        }, [
          _createVNode(_component_Unit, {
            unit: unit,
            classesPlan: _ctx.classesPlan,
            editingUnitId: _ctx.editingUnitId,
            onEdit: _ctx.onEdit,
            onEditSelectedClass: _ctx.editSelectedClass,
            onDeleteSelectedClass: _ctx.deleteSelectedClass,
            index: index
          }, null, 8, ["unit", "classesPlan", "editingUnitId", "onEdit", "onEditSelectedClass", "onDeleteSelectedClass", "index"]),
          _createVNode(_component_Divider)
        ]))
      }), 128)),
      (!_ctx.editingUnitId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("label", {
              class: "add-unit",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addUnit && _ctx.addUnit(...args)))
            }, " + Agregar unidad ")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}